import { Component, Input, OnInit } from '@angular/core';
import { AppConfig } from '@config/app.config';

@Component({
  selector: 'app-loading-view',
  templateUrl: './loading-view.component.html'
})
export class LoadingViewComponent implements OnInit {
  @Input() title: string;
  @Input() home = false;

  constructor(public appConfig: AppConfig) {}

  ngOnInit() {}
}
